import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";


import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app-routing.module";
import {MainComponent} from "./base-component/main.component";
import {NgProgressModule} from "ng2-progressbar";
import {ToastyModule} from "ng2-toasty";
import {SliderComponent} from "./base-component/slider.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';
import {RouterModule} from "@angular/router";
import {environment} from "../environments/environment";
import {AngularFireModule} from "angularfire2";
import {AngularFireDatabaseModule} from "angularfire2/database";
import {AngularFireStorageModule} from "angularfire2/storage";
import {PublicComponent} from "./public/public.component";
import {AngularFirestoreModule} from "angularfire2/firestore";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {LoginComponent} from "./login/login.component";
import {LocalStorageService, Ng2Webstorage} from "ngx-webstorage";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {DemoUtilsModule} from "../app/common/module";
import localeEs from "@angular/common/locales/es";

import { ChartsModule } from 'ng2-charts/ng2-charts';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    SliderComponent,
    PublicComponent,
    LoginComponent
  ],
  imports: [
    DemoUtilsModule,
    ChartsModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    NgProgressModule,
    ReactiveFormsModule,
    ToastyModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    NgbModule.forRoot(),
    AngularFireStorageModule,
    Ng2Webstorage
  ],
  providers: [
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts